import ApiClient from "@common/api/ApiClient";

class IncidentClient extends ApiClient {
  constructor() {
    super("Incident");
    this.setApiUrlKey("comp_api_url");
  }

  MetaData = async (siteGuid = null) => {
    if (!siteGuid) {
      return await this.get("Create");
    }
    return await this.get(`Create?guid=${siteGuid}`);
  };

  Update = async (payload) => {
    return await this.post(`Update`, payload);
  };

  Create = async (payload) => {
    return await this.post(`Create`, payload);
  };

  Read = async (id) => {
    const record = await this.get(
      `Read?id=${id}&includeImages=true&includeThumbnails=true`,
    );
    return { record };
  };

  ReadForUpdate = async (id) => {
    return await this.get(
      `Update?id=${id}&includeImages=true&includeThumbnails=true`,
    );
  };
}

const client = new IncidentClient();

export default client;
